import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectDocOptions } from 'shared-pages/components/select-dlg/fs-adr';
import { buildWhereFromDocFilter } from 'shared-pages/common/filters-helpfunc';
import { FormFieldMultiRegionDlg } from 'shared-pages/components/select-dlg/fs-multi-region';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { name: likeObj },
          { addressLine1: likeObj },
          { phone: likeObj },
          { companyVat: likeObj },
          { companyTaxOffice: likeObj },
        ],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (!!values.contract)
      where = buildWhereFromDocFilter(where, values.contract, 'contractNo', 'contractExpDate');
    if (!!values.insurance)
      where = buildWhereFromDocFilter(
        where,
        values.insurance,
        'insurancePolicyNumber',
        'insuranceExpirationDate',
      );
    if (!!values.hazardous)
      where = buildWhereFromDocFilter(
        where,
        values.hazardous,
        'hazardousWastePermit',
        'hazardousWasteExpDate',
      );
    if (!!values.adr)
      where = buildWhereFromDocFilter(where, values.adr, '', 'adrConsultantAgrExpDate');

    if (values.regionId) {
      where = {
        ...where,
        // '$containertypesMaterials.regionId$': { $in: [JSON.parse(values.regionId)] },
        regionIds: values.regionId,
      };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    regionId: initialValues?.regionId ?? undefined,
    regionName: initialValues?.regionName ?? '',
    contract: initialValues?.contract ?? undefined,
    hazardous: initialValues?.hazardous ?? undefined,
    insurance: initialValues?.insurance ?? undefined,
    adr: initialValues?.adr ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Όνομα, Διεύθυνση, Τηλέφωνο, ΑΦΜ, ΔΟΥ )')}
          type="search"
          disable={disable}
        />
        <FieldSelectDocOptions
          withBlank={false}
          label={t('Σύμβαση')}
          name="contract"
          as={FormCol}
        />
        <FieldSelectDocOptions
          withBlank={false}
          label={t('Άδεια Επικινδύνων')}
          name="hazardous"
          as={FormCol}
        />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
      <Row>
        <FormFieldMultiRegionDlg
          label={t('Περιφέρειες')}
          as={FormCol3}
          initValueName={filters.regionName}
          initValueId={filters.regionId}
          onValueChange={(valueId, valueName) => {
            filters.regionId = valueId;
            filters.regionName = valueName;
          }}
          initFilters={{ isActive: true }}
          disable={disable}
        />
        <FieldSelectDocOptions
          withBlank={false}
          label={t('Ασφαλιστήριο')}
          name="insurance"
          as={FormCol}
        />

        <FieldSelectDocOptions
          withBlank={false}
          label={t('Συμβούλου ADR')}
          name="adr"
          as={FormCol}
        />
      </Row>
    </FormFilterCard>
  );
};

